import React from "react";
import { useTranslation } from "react-i18next";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";
import { capitalize } from "oc/utils/capitalize";
import getMonthList from "oc/utils/get-month-list";

interface OcMonthSelectProps {
  id: string;
  label: string;
  selectedMonth: number | string | null;
  onSelectMonth: (month: number) => void;
  monthList: { index: string; name: string }[];
  disabled?: boolean;
  startMonth: number;
  width: string;
}

export const OcMonthSelect: React.FC<OcMonthSelectProps> = ({
  id,
  label,
  selectedMonth,
  onSelectMonth,
  monthList,
  disabled = false,
  startMonth,
  width,
}) => {
  const { t, i18n } = useTranslation();
  const isMobile = useOcIsMobile();
  const months: { index: number; name: string }[] = getMonthList(
    i18n.language,
    monthList.map((item) => Number(item.index)),
  );

  // Normalize selectedMonth to number (handles "08" -> 8, "12" -> 12, etc.)
  const normalizedMonth = selectedMonth != null ? Number(selectedMonth) : null;

  return (
    <FormControl
      variant="outlined"
      sx={{
        minWidth: isMobile ? "100%" : width,
        width: isMobile ? "100%" : width,
        backgroundColor: "white",
      }}
      disabled={disabled}
    >
      <InputLabel htmlFor={id}>{capitalize(label)}</InputLabel>
      <Select
        value={normalizedMonth || ""}
        onChange={(o) => onSelectMonth(Number(o.target.value))}
        label={label}
        inputProps={{
          id: id,
          name: id,
          style: {
            backgroundColor: "white",
          },
        }}
        disabled={disabled}
      >
        <MenuItem value="">-- {t("OC_NOT_SELECTED")} --</MenuItem>
        {months.map((item: { index: number; name: string }, index: number) => (
          <MenuItem
            id={`${index}-${id}`}
            key={item.index}
            disabled={item.index < startMonth}
            value={item.index}
          >
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default OcMonthSelect;
